import { useState } from "react";
import { emailMessagesColumns } from "./renewalsColumns";
import { SearchableTable } from "../shared/table/SearchableTable";
import { Modal } from "antd";
import "./EmailMessages.css";

const EmailMessages = ({ messages, loading }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const handleMessageClick = (html) => {
    setModalContent(html);
    setModalVisible(true);
  };

  return (
    <>
      <SearchableTable
        keyColumn="Id"
        dataSource={messages}
        columns={emailMessagesColumns(handleMessageClick)}
        loading={loading}
        size="small"
        rowKey={(e) => e.Id}
        hideClearFiltersButtons={true}
      />
      <Modal
        width={700}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        <div
          className="html-preview"
          dangerouslySetInnerHTML={{ __html: modalContent }}
        />
      </Modal>
    </>
  );
};

export default EmailMessages;
